<app-page-breadcrumb pageTitle="Límites de envío (mi empresa)"></app-page-breadcrumb>

<app-component-card>
  <p class="mb-4 text-sm text-gray-500 dark:text-gray-400">
    Ajusta los límites de envío de email de cada canal de tu empresa. Los valores no pueden
    superar el tope global definido por el administrador del sistema. Restablecer un canal
    vuelve a heredar el límite global.
  </p>

  @if (error) {
    <p class="mb-3 text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  }

  @if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  } @else if (rows.length === 0) {
    <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
      No hay canales de envío disponibles.
    </p>
  } @else {
    <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
      @for (row of rows; track trackByChannel($index, row)) {
        <div class="rounded-xl border border-gray-200 dark:border-gray-700 p-4">
          <!-- Cabecera de la tarjeta -->
          <div class="flex items-start justify-between gap-3 mb-3">
            <div>
              <h4 class="text-base font-semibold text-gray-900 dark:text-white">{{ row.label }}</h4>
              <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
                Tope global:
                <span class="font-medium text-gray-700 dark:text-gray-300">
                  máx. {{ row.globalDailyLimit ?? '—' }}/día, {{ row.globalPerMinuteLimit ?? '—' }}/min
                </span>
              </p>
            </div>
            @if (row.hasOverride) {
              <app-badge color="primary">Personalizado</app-badge>
            } @else {
              <app-badge color="info">Heredando global</app-badge>
            }
          </div>

          <!-- Campos editables -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
                Límite diario
              </label>
              <input
                type="number"
                min="0"
                [max]="row.globalDailyLimit ?? null"
                [(ngModel)]="row.dailyLimit"
                class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
              />
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
                Por minuto
              </label>
              <input
                type="number"
                min="0"
                [max]="row.globalPerMinuteLimit ?? null"
                [(ngModel)]="row.perMinuteLimit"
                class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
              />
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
                Burst
              </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="row.burst"
                placeholder="—"
                class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
              />
            </div>
            <div class="flex items-end">
              <label class="inline-flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  [(ngModel)]="row.enabled"
                  class="h-4 w-4 rounded border-gray-300 dark:border-gray-600 text-brand-500 focus:ring-brand-500"
                />
                <span class="text-sm text-gray-700 dark:text-gray-300">Habilitado</span>
              </label>
            </div>
          </div>

          <!-- Error de validación inline -->
          @if (validationError(row); as vErr) {
            <p class="mt-2 text-xs text-error-600 dark:text-error-400">{{ vErr }}</p>
          }

          <!-- Acciones -->
          <div class="mt-4 flex items-center justify-end gap-2">
            @if (row.hasOverride) {
              <app-button
                variant="outline"
                size="sm"
                [disabled]="row.saving || row.resetting"
                (btnClick)="restablecer(row)"
              >
                Restablecer al global
              </app-button>
            }
            <app-button
              variant="primary"
              size="sm"
              [disabled]="!canSave(row)"
              (btnClick)="guardar(row)"
            >
              Guardar
            </app-button>
          </div>
        </div>
      }
    </div>
  }
</app-component-card>
